import { jsx as _jsx } from "react/jsx-runtime";
import { TimelineDot as ExperimentalTimelineDot } from "@/components/ui/ExperimentalTimeline";
export function TimelineDotDefault() {
    return _jsx(ExperimentalTimelineDot, {});
}
export function TimelineDotSuccess() {
    return _jsx(ExperimentalTimelineDot, { status: "done" });
}
export function TimelineDotError() {
    return _jsx(ExperimentalTimelineDot, { status: "error" });
}
